import { AppPathEnum } from '../enums/appPathEnum';

const retryPaths: readonly string[] = [
    AppPathEnum.MEMBERSHIP_ONBOARDING, AppPathEnum.MEMBERSHIP_TRANSFER,
    AppPathEnum.MEMBERSHIP_RENEWAL, AppPathEnum.AFFILIATE_ASSOCIATE,
    AppPathEnum.PCS_ENROLMENT, AppPathEnum.PCS_RE_ENROLL, AppPathEnum.DONATION_DASHBOARD,
    AppPathEnum.DONATION_IRELAND, AppPathEnum.DONATION_UK, AppPathEnum.DONATION_USA
];

/** Return only approved same-origin routes, never an arbitrary navigation target. */
export function safePaymentRetryUrl(value: string | null, origin: string): string | null {
    if (!value) return null;
    try {
        const url = new URL(value, origin);
        if (url.origin !== origin || !['https:', 'http:'].includes(url.protocol)
            || url.username || url.password) return null;
        const path = url.pathname.replace(/\/$/, '');
        if (!retryPaths.includes(path)) return null;
        const query = new URLSearchParams();
        for (const key of ['ref', 'expectedStep', 'cancelPayment']) {
            const parameter = url.searchParams.get(key);
            if (parameter !== null) query.set(key, parameter);
        }
        const search = query.toString();
        return path + (search ? `?${search}` : '');
    } catch {
        return null;
    }
}
